<template>
     <vx-card :title="$t('about_profile')">
        <div class="item mb-3" v-if="info.cathedra">
            <label class="text-primary font-medium">{{$t('cathedra')}}:</label>
            <div class="val">
                {{info.cathedra.name}}
            </div>
        </div>
        <div class="item mb-3" v-if="info.faculty">
            <label class="text-primary font-medium">{{$t('faculty')}}:</label>
            <div class="val">
                {{info.faculty.name}}
            </div>
        </div>
        <div class="item mb-3" v-if="info.position">
            <label class="text-primary font-medium">{{$t('position')}}:</label>
            <div class="val">
                {{info.position.name}}
            </div>
        </div>
        <div class="item mb-3" v-if="info.study_year">
            <label class="text-primary font-medium">{{$t('study_year')}}:</label>
            <div class="val">
                {{info.study_year}}
            </div>
        </div>
        <vs-button class="w-full" color="primary" @click="userMessage(uid)"  type="border">{{$t('write_a_message')}}</vs-button>

    </vx-card>

</template>

<script>
    import userSetting from '@/localNodeModules/setting/user.js'

    export default {
        name:'',
        mixins:[userSetting],
        props:{
            info:{
                type:Object,
            },
            uid:{
                type:String,
            }
        }

    }
</script>